<div class="container-fluid p-0">
  <div class="grid grid-cols-1">
    <div class="col-span-1">
      <ng-content></ng-content>
      <div class="container-fluid p-0">
        <!-- <div class="row">
            <h2 class="">Species and Planting Materials required for "Target Property/Paddock"</h2>
          </div> -->
        <span class="font-medium">Introduction</span>

        <div class="grid grid-cols-1">
          <p class="leading-relaxed">
            This form provides guidance on the types of tree species you can
            plant for different end-uses, materials likely required at the time
            of establishment, and advice on sourcing seedlings and planting
            labour. Note that you will likely have to order seedlings up to a
            year in advance, so good planning is essential.
          </p>
        </div>

        <div class="grid grid-cols-1">
          <p class="">
            For any timber production enterprise, genetics matter so be sure to
            discuss genetics options with your supplier prior to purchase.
          </p>
        </div>

        <div class="grid grid-cols-1">
          <div class="my-2">
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Primary Use</label
            >
            <select
              (change)="
                questionGenrationService.generateSecondaryUseItemList($event)
              "
              class="custom-select"
              aria-label="Primary use selection"
            >
              <option selected>Select the primary use</option>
                              @for (item of questionGenrationService.primaryUseArray; track item) {
                  <option
                    value="{{ item }}"
                  >
                    {{ item }}
                  </option>
                }
            </select>
          </div>

                    @if (questionGenrationService.secondaryUseArray.length > 0) {
            <div
              [@inOutAnimation]
              class="my-2"
            >
              <label class="block text-sm font-medium text-gray-700 mb-2"
                >Secondary Use</label
              >
              <select
                (change)="
                  questionGenrationService.generateRecommendedSpeciesUseItemList(
                    $event
                  )
                "
                class="custom-select"
                aria-label="Secondary use selection"
              >
                <option selected>Select the Secondary use</option>
                @for (item of questionGenrationService.secondaryUseArray; track item) {
                  <option
                    value="{{ item }}"
                  >
                    {{ item }}
                  </option>
                }
              </select>
            </div>
          }

                      @if (questionGenrationService.recommendedSpeciesArray.length > 0) {
              <div
                [@inOutAnimation]
                class="my-2"
              >
                <label class="block text-sm font-medium text-gray-700 mb-2"
                  >Recommended species</label
                >
                <select
                  (change)="
                    questionGenrationService.generateRecommendedSpeciesTable(
                      $event
                    );
                    passValuesToParent()
                  "
                  class="custom-select"
                  aria-label="Recommended species selection"
                >
                  <option selected>Select recommended species</option>
                  @for (item of questionGenrationService.recommendedSpeciesArray; track item) {
                    <option
                      value="{{ item }}"
                    >
                      {{ item }}
                    </option>
                  }
                </select>
              </div>
            }
        </div>

        <!-- <div [@inOutAnimation] *ngIf="questionGenrationService.selectedRecommendedSpecies" class="row mt-3">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Species Description</th>
                  <th scope="col">Recommended Planting Layout</th>
                  <th scope="col">Along Row Spacing</th>
                  <th scope="col">Between Row Spacing</th>
                  <th scope="col">URL to Info Sheet</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td scope="row">{{questionGenrationService.selectedRecommendedSpeciesTable["Species Description"]}}</td>
                  <td scope="row">
                    {{questionGenrationService.selectedRecommendedSpeciesTable["Recommended Planting Layout"]}}</td>
                  <td scope="row">{{questionGenrationService.selectedRecommendedSpeciesTable["Along Row Spacing"]}}</td>
                  <td scope="row">{{questionGenrationService.selectedRecommendedSpeciesTable["Between Row Spacing"]}}</td>
                  <td scope="row">{{questionGenrationService.selectedRecommendedSpeciesTable["URL to Info Sheet"]}}1</td>
                </tr>
              </tbody>
            </table>
          </div> -->

        @if (questionGenrationService.selectedRecommendedSpecies) {
          <div
            [@inOutAnimation]
            class="grid grid-cols-1 mt-4"
          >
          <h5 class="">
            Guidelines for planting layout based on your chosen use and species
          </h5>
        </div>
        }

        @if (questionGenrationService.selectedRecommendedSpecies) {
          <div
            class="flex flex-col gap-4 mt-3"
            [@inOutAnimation]
          >
          <div class="md:col-span-3">
            <div class="mb-3">
             <span class="font-medium">Species Description</span>
              <div
                class="prose prose-sm max-w-none species-description-content"
                [innerHTML]="
                  questionGenrationService.selectedRecommendedSpeciesTable[
                    'Species Description'
                  ]
                "
              ></div>
            </div>
          </div>

          <div class="md:col-span-1">
            <div class="mb-3 text-wrap-something">
              <span class="font-medium">More information</span>
              <p>
                <a
                  target="_blank" class="text-blue-600 underline hover:text-blue-800 cursor-pointer"
                  [href]="
                    questionGenrationService.selectedRecommendedSpeciesTable[
                      'URL to Info Sheet'
                    ]
                  "
                  >Species Guides</a
                >
              </p>
            </div>
          </div>

          @if (questionGenrationService.materialSpeciesPlantingForm) {
            <div
              class="formGroupElement flex flex-col gap-4"
              [formGroup]="questionGenrationService.materialSpeciesPlantingForm"
            >
            <!-- Left Column: Planting Layout and Spacing -->
            <div class="flex-grow">
              <div class="flex flex-row justify-between">
                <section class="flex flex-col gap-1">
                  <span class="font-medium">Recommended planting layout</span>
                  <p>
                    {{
                      questionGenrationService.selectedRecommendedSpeciesTable[
                        'Recommended Planting Layout'
                      ]
                    }}
                  </p>
                </section>

                <section class="flex gap-1">
                  <label class="flex-grow"
                    >Along row spacing:
                    <input
                      appNumbersOnlyInputDirective
                      type="number"
                      class="form-control"
                      (keyup)="
                        questionGenrationService.recalculateCalculationsValues();
                        passValuesToParent()
                      "
                      formControlName="alongRowSpacing"
                      placeholder="Along row spacing "
                    />
                  </label>

                  <label class="flex-grow"
                    >Between row spacing:
                    <input
                      appNumbersOnlyInputDirective
                      type="number"
                      class="form-control"
                      (keyup)="
                        questionGenrationService.recalculateCalculationsValues();
                        passValuesToParent()
                      "
                      formControlName="betweenRowSpacing"
                      placeholder="Between row spacing"
                    />
                  </label>
                </section>
              </div>
            </div>

            <!-- Right Column: Calculations -->
            <div class="lg:col-span-1">
                             @if (questionGenrationService.selectedRecommendedSpecies) {
                 <div
                   [@inOutAnimation]
                   class="mb-3"
                 >
                <h5 class="mb-3">Calculations</h5>

                <div class="grid grid-cols-2 gap-4 calculations-grid">
                  <div class="mb-3">
                    <label class="form-label fw-bolder text-sm"
                      >Stems per hectare (SPH)</label
                    >
                    <p class="fs-5 font-semibold text-blue-600">
                      {{
                        questionGenrationService.stemsPerHectare | toPrecision : 0
                      }}
                    </p>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bolder text-sm"
                      >Number seedlings required</label
                    >
                    <p class="fs-5 font-semibold text-blue-600">
                      {{
                        questionGenrationService.numberSeedingsRequired | truncate | number
                      }}
                    </p>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bolder text-sm"
                      >Number tree socks required</label
                    >
                    <p class="fs-5 font-semibold text-blue-600">
                      {{
                        questionGenrationService.numberTreeStocksRequired
                          | truncate | number
                      }}
                    </p>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bolder text-sm"
                      >Amount of fertiliser required (kg)
                    </label>
                    <p class="fs-5 font-semibold text-blue-600">
                      {{
                        questionGenrationService.amountFertiliserRequired
                         | truncate | number
                      }}
                    </p>
                  </div>
                </div>

                <div class="mt-4">
                  <p class="fs-6 text-gray-600">
                    Fertiliser amount is based on an assumed 125g DAP (Di
                    Ammonium Phosphate) per seedling. Please note that although
                    fertiliser application at planting is a standard practice in
                    the forestry industry, it is optional, and you should seek
                    further advice as to whether this is required or not for
                    your site. Generally, ex-pasture sites do not require
                    fertiliser application.
                  </p>
                </div>
              </div>
            }
            </div>
          </div>
        }
        </div>
      }
      </div>
    </div>
  </div>
</div>
